<script lang="ts">
	import type { ProductAdditionalInfo } from "../../../core/schema/Product.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let spec: ProductAdditionalInfo;
</script>

<div class="flex w-full justify-between gap-2 rounded-lg bg-gray-300 md:p-4">
	{#if spec.name}
		<span class="text-3xs text-primary self-start font-normal uppercase leading-5">{nbspify(spec.name)}</span>
	{:else}
		<span class="flex-grow"></span>
	{/if}
	{#if spec.value}
		<span class="text-3xs self-end text-right font-semibold leading-5">{nbspify(spec.value)}</span>
	{/if}
</div>
